module.exports = __webpack_public_path__ + "static/img/2.7b5bbc22.jpg";